'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ImageZoom = require('../components/ImageZoom');

var _ImageZoom2 = _interopRequireDefault(_ImageZoom);

var _drawer = require('drawer');

var _drawer2 = _interopRequireDefault(_drawer);

var _Slider = require('../utils/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _loadjs = require('loadjs');

var _loadjs2 = _interopRequireDefault(_loadjs);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

require('../../styles/sections/product-features.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductFeatures = function () {
  function ProductFeatures(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ProductFeatures);

    this.el = section.el;
    this.productFeatureSlider = [];
    this.observers = [];
    this.videos = [];
    this.ev = new _EventHandler2.default();

    this.yotpoEl = this.el.querySelector('[data-yotpo-url]');

    if (this.el.querySelector('.rimg-video')) {
      (0, _loadjs2.default)('https://embed.cloudflarestream.com/embed/sdk.latest.js', function () {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var videoObject = _this.videos.find(function (video) {
              return video.id === entry.target.dataset.videoId;
            });
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              videoObject.stream.play();
              if (videoObject.tracked === false) {
                videoObject.tracked = true;
                window.dataLayer.push({ 'event': 'Played Video - Below the Fold', 'videoId': entry.target.dataset.videoId });
              }
            } else {
              videoObject.stream.pause();
            }
          });
        }, {
          rootMargin: '0px 0px 0px 0px'
        });

        _this.el.querySelectorAll('.rimg-video').forEach(function (video) {
          if (video.dataset.src) {
            video.src = video.dataset.src;
          }
          _this.videos.push({
            id: video.dataset.videoId,
            el: video,
            stream: Stream(video),
            tracked: false
          });

          io.observe(video);
        });

        _this.observers.push(io);
      });
    }

    this.el.querySelectorAll('.product-feature-toggle').forEach(function (feature) {
      _this.ev.register(feature, 'click', function (e) {
        e.currentTarget.classList.toggle('expanded');
      });
    });

    if (this.el.querySelector('.product-feature-pricing_section')) {
      this.pricingPhilosophyDrawer = new _drawer2.default(document.getElementById('drawer-pricing-philosophy'));

      this.ev.register(this.el.querySelector('.pricing-philosophy-trigger'), 'click', function (e) {
        e.preventDefault();
        _this.pricingPhilosophyDrawer.open();
      });
    }

    var pswpJsonElement = this.el.querySelector('[data-photoswipe-feature-images]');
    if (pswpJsonElement) {
      var pswpJson = JSON.parse(pswpJsonElement.innerHTML);

      this.imageZoom = new _ImageZoom2.default(pswpJson.images);

      this.el.querySelectorAll('[data-image-zoom]').forEach(function (image) {
        _this.ev.register(image, 'click', function (e) {
          return _this.imageZoom.open(e.currentTarget.dataset.imageZoom, e.currentTarget);
        });
      });
    }

    var reviewsDrawer = document.getElementById('drawer-product-reviews');

    if (reviewsDrawer) {
      this.productReviewsDrawer = new _drawer2.default(reviewsDrawer);

      this.ev.register(this.el.querySelector('.product-reviews-slider-cta a'), 'click', function (e) {
        e.preventDefault();
        _this.productReviewsDrawer.open();
      });
    }

    if (this.el.querySelector('.product-feature-product_details_buttons')) {
      this.ev.register(this.el.querySelector('.product-bubbles-wrapper'), 'click', function (e) {
        e.preventDefault();
        _this.el.querySelector('.product-feature-product_details').classList.add('product-feature-expanded');
        e.currentTarget.classList.toggle('expanded');

        e.currentTarget.parentElement.querySelectorAll('.expanded').forEach(function (expanded) {
          expanded.classList.remove('expanded');
        });

        var pdpClick = _this.ev.register(document, 'click', function (e) {
          if (!e.target.closest('.product-bubbles-wrapper')) {
            _this.el.querySelector('.product-bubbles-wrapper.expanded').classList.remove('expanded');
            _this.ev.unregister(pdpClick);
          }
        });
      });
    }

    if (this.el.querySelector('.product-feature-slider')) {
      this.el.querySelectorAll('.product-slideshow').forEach(function (slideshow) {
        var flkty = new _Slider2.default(slideshow, {
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          groupCells: true
        });

        _this.productFeatureSlider.push(flkty);
      });
    }

    this.el.querySelectorAll('.product-feature-columns .grid-items.slider').forEach(function (el) {
      _this.productFeatureSlider.push(new _Slider2.default(el, {
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: true
      }));
    });

    if (this.el.querySelector('.yotpo.product-reviews-slider')) {
      this.productReviewsSlider = new _Slider2.default(this.el.querySelector('.yotpo.product-reviews-slider'), {
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        pageDots: false,
        groupCells: true
      });
    }

    if (this.el.querySelector('.product-feature-product_details')) {
      var triggerState = function triggerState(index) {
        productDetailsTriggers.forEach(function (el) {
          return el.classList.remove('selected');
        });
        productDetailsTriggerWrappers.forEach(function (el) {
          return el.classList.remove('selected');
        });
        productDetailsTriggers[index].classList.add('selected');
        productDetailsTriggerWrappers[index].classList.add('selected');
        productDetailsTriggers.forEach(function (el) {
          return el.classList.add('reset-animation');
        });
        setTimeout(function () {
          productDetailsTriggers.forEach(function (el) {
            return el.classList.remove('reset-animation');
          });
        }, 150);
        if (productDetailsCounter) {
          productDetailsCounter.classList.add('animate');
          setTimeout(function () {
            productDetailsCounter.innerText = index + 1;
          }, 150);
          setTimeout(function () {
            productDetailsCounter.classList.remove('animate');
          }, 300);
        }
      };

      var productDetailsTriggers = this.el.querySelectorAll('.product-details-trigger');
      var productDetailsTriggerWrappers = this.el.querySelectorAll('.product-details-trigger-wrapper');
      var productDetailsCounter = this.el.querySelector('.product-details-counter');

      productDetailsTriggers.forEach(function (el) {
        _this.ev.register(el, 'click', function (e) {
          e.preventDefault();
          if (e.currentTarget.classList.contains('selected')) {
            _this.productDetailsSlider.select(productDetailsTriggers.length);
          } else if (e.currentTarget.dataset && e.currentTarget.dataset.counter) {
            _this.productDetailsSlider.select(e.currentTarget.dataset.counter);
          }
        });
      });

      var initialIndex = document.querySelectorAll('.product-details-slider .product-details-slide').length - 1;

      this.el.querySelector('.product-details-slider').insertAdjacentHTML('beforeend', '<div class="product-details-slide info-slide"><p><i>Tap a \'+\' above to learn more.</i></p></div>');

      var productDetailsSlider = this.el.querySelector('.product-details-slider');

      this.productDetailsSlider = new _Slider2.default(productDetailsSlider, {
        wrapAround: true,

        prevNextButtons: false,
        pageDots: false,
        initialIndex: initialIndex,
        on: {
          select: function select(index) {
            triggerState(index);
          }
        }
      });
    }

    this.yotpo();

    this.heroSlider = this.heroSlider.bind(this);

    this.el.querySelectorAll('.product-feature-text_over_image_slider').forEach(this.heroSlider);
  }

  (0, _createClass3.default)(ProductFeatures, [{
    key: 'yotpo',
    value: function yotpo() {
      var _this2 = this;

      if (!this.yotpoEl) return;

      if ((0, _typeof3.default)(window.yotpo) === 'object') {
        window.yotpo.refreshWidgets();
        window.yotpo.onAllWidgetsReady(function (e) {
          window.dataLayer && window.dataLayer.push({ "event": "optimize.yotpoLoaded" });
        });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              io.unobserve(entry.target);
              (0, _loadjs2.default)([_this2.yotpoEl.dataset.yotpoUrl, _this2.yotpoEl.dataset.yotpoUrl2], function () {
                window.yotpo.onAllWidgetsReady(function (e) {
                  window.dataLayer && window.dataLayer.push({ "event": "optimize.yotpoLoaded" });
                });
                Yotpo.scrollToTop = function (e, t) {
                  if (e.offsetParent && e.offsetParent.scrollTop > 0 && e.offsetParent !== document.body) Yotpo.scrollTo(e.offsetParent - 78, 0, 500, !0, null, t);else {
                    var i = document.documentElement.scrollTop > 0 ? document.documentElement : document.body;Yotpo.scrollTo(i, e.getBoundingClientRect().top + i.scrollTop - 78, 500, !0, null, t);
                  }
                };
              });
            }
          });
        }, {
          rootMargin: '20% 0px'
        });

        io.observe(this.yotpoEl);
        this.observers.push(io);
      }
    }
  }, {
    key: 'heroSlider',
    value: function heroSlider(el) {
      var _this3 = this;

      el.querySelectorAll('[data-toggle-hero]').forEach(function (toggle) {
        _this3.ev.register(toggle, 'click', function (e) {
          var showHero = el.querySelector('[data-hero="' + e.currentTarget.dataset.toggleHero + '"]');
          var mobileShowHero = el.querySelector('[data-mobile-hero="' + e.currentTarget.dataset.toggleHero + '"]');
          if (showHero.classList.contains('shown')) return;
          var shownHero = el.querySelector('[data-hero].shown');
          var mobileShownHero = el.querySelector('[data-mobile-hero].shown');
          var endEv = _this3.ev.register(showHero, 'transitionend', function (e) {
            shownHero.classList.remove('shown');
            mobileShownHero.classList.remove('shown');
            showHero.classList.remove('transitioning');
            mobileShowHero.classList.remove('transitioning');
            _this3.ev.unregister(endEv);
          });
          el.querySelectorAll('[data-toggle-hero].shown').forEach(function (shownToggle) {
            shownToggle.classList.remove('shown');
          });
          toggle.classList.add('shown');
          showHero.classList.add('will-show');
          showHero.classList.add('transitioning');
          showHero.scrollTop;
          showHero.classList.remove('will-show');
          showHero.classList.add('shown');
          mobileShowHero.classList.add('will-show');
          mobileShowHero.classList.add('transitioning');
          mobileShowHero.scrollTop;
          mobileShowHero.classList.remove('will-show');
          mobileShowHero.classList.add('shown');
        });
      });
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.ev.unregisterAll();
      if (this.productReviewsDrawer) {
        this.productReviewsDrawer.unload();
      }
      if (this.imageZoom) {
        this.imageZoom.unload();
      }
      if (this.pricingPhilosophyDrawer) {
        this.pricingPhilosophyDrawer.unload();
      }
      this.observers.forEach(function (io) {
        return io.disconnect();
      });
      if (this.productDetailsSlider) {
        this.productDetailsSlider.destroy();
      }
      if (this.productReviewsSlider) {
        this.productReviewsSlider.destroy();
      }
      this.productFeatureSlider.forEach(function (slider) {
        return slider.destroy();
      });
    }
  }]);
  return ProductFeatures;
}();

exports.default = ProductFeatures;